import React from 'react'
import PropTypes from 'prop-types'
import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import DeleteOutlineOutlined from 'components/material-symbol/icons/DeleteOutline'
import Dialog from 'components/dialog'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 7, 1, 3),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
  },
  subtitle: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.75),
  },
  content: {
    padding: theme.spacing(1, 3, 2),
  },
  bodyText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))

function DeleteNoteDialog({ open, onClose, onConfirm, disabled }) {
  const classes = useStyles()

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      showCloseButton
      fullWidth
      maxWidth="xs"
    >
      {() => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Delete note
            </Typography>
            <Typography className={classes.subtitle}>
              This note will be removed from this student.
            </Typography>
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <Typography className={classes.bodyText}>
              Are you sure you want to delete this note? This cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button
              color="primary"
              size="large"
              onClick={onClose}
              disabled={disabled}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              size="large"
              disableElevation
              startIcon={<DeleteOutlineOutlined fontSize="small" />}
              onClick={onConfirm}
              disabled={disabled}
            >
              Delete
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DeleteNoteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

DeleteNoteDialog.defaultProps = {
  disabled: false,
}

export default DeleteNoteDialog
